<template>
  <v-text-field
    :value="formattedValue"
    class="inline-input"
    outlined
    dense
    hide-details
    :disabled="disabled"
    @input="unformatValue"
    @keydown="preventNonNumericInput"
  />
</template>

<script>
export default {
  name: 'InlineNumberInput',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: () => 7,
    },
  },
  computed: {
    formattedValue() {
      return this.localeString(this.value, 0)
    },
  },
  methods: {
    preventNonNumericInput(event) {
      const keyPressed = event.key
      const isControlKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(keyPressed)
      const inputLength = event.target.value.length
      const isFullSelection = event.target.selectionStart === 0 && event.target.selectionEnd === inputLength

      if (isControlKey) {
        return
      }
      if (!/^\d$/.test(keyPressed)) {
        event.preventDefault()
        return
      }
      if (isFullSelection) {
        return
      }
      if (inputLength > this.limit - 1) {
        event.preventDefault()
      }
    },
    unformatValue(value) {
      const numericValue = value.replace(/\D/g, '')
      this.$emit('input', parseInt(numericValue || '0', 10))
    },
  },
}
</script>

<style lang="scss" scoped>
.inline-input {
  padding: 0;
  margin: 0;
  width: 52px;
  max-width: 52px;
  color: $marca-0-l40 !important;

  ::v-deep .v-label {
    color: $marca-0-l40;
    font-size: 14px;
  }

  ::v-deep fieldset {
    border-color: $marca-0-l40;
  }
}
</style>
